import type { StarterDashboardRootPageDataQuery } from '../rootPageData.graphql';

type Petition = NonNullable<StarterDashboardRootPageDataQuery['petition']>;
export function getPetitionShareVisuals(petition: Petition) {
	if (!petition.shareVisuals) return [];
	if (petition.shareVisuals.__typename !== 'ShareVisualsConnection') return [];
	return petition.shareVisuals.nodes;
}
